import { AuthEngine } from "@deliverr/core-auth";
import { SortationPortalClient } from "@deliverr/sortation-client";

export const sortationClientAuth0 = new SortationPortalClient({
  baseURL: process.env.SORTATION_URL!,
  authEngine: AuthEngine.AUTH0,
});
